import PropTypes from 'prop-types';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';

import { statusChipSx } from './tableChipStyles';

// ==============================|| TABLE STATUS CHIP ||============================== //

const getStatusColorSx = (colorKey, active) => {
  switch (colorKey) {
    case 'success':
      return {
        bgcolor: '#1f5b40 !important',
        color: '#fff !important',
        border: '1px solid #1f5b40 !important',
        '&:hover': { bgcolor: '#133a28 !important' },
        '& .MuiChip-label': { color: '#fff !important' }
      };
    case 'warning':
      return {
        bgcolor: 'rgba(237, 108, 2, 0.12) !important',
        color: '#e65100 !important',
        border: '1px solid rgba(237, 108, 2, 0.35) !important',
        '&:hover': { bgcolor: 'rgba(237, 108, 2, 0.2) !important' },
        '& .MuiChip-label': { color: '#e65100 !important' }
      };
    case 'error':
      return {
        bgcolor: 'rgba(198, 40, 40, 0.1) !important',
        color: '#b71c1c !important',
        border: '1px solid rgba(198, 40, 40, 0.28) !important',
        '&:hover': { bgcolor: 'rgba(198, 40, 40, 0.18) !important' },
        '& .MuiChip-label': { color: '#b71c1c !important' }
      };
    case 'default':
    case 'secondary':
      return {
        bgcolor: 'rgba(31, 91, 64, 0.08) !important',
        color: '#5c6b63 !important',
        border: '1px solid rgba(31, 91, 64, 0.15) !important',
        '&:hover': { bgcolor: 'rgba(31, 91, 64, 0.12) !important' },
        '& .MuiChip-label': { color: '#5c6b63 !important' }
      };
    default:
      return statusChipSx(active);
  }
};

export default function TableStatusChip({
  active,
  label,
  color,
  loading = false,
  loadingLabel = 'Updating...',
  onClick,
  sx = {}
}) {
  const displayLabel = loading ? loadingLabel : label ?? (active ? 'Active' : 'Inactive');
  const effectiveColor = color || (active !== undefined ? (active ? 'success' : 'default') : undefined);

  return (
    <Chip
      label={displayLabel}
      size="small"
      color={color || (active ? 'success' : 'default')}
      variant="filled"
      onClick={onClick}
      icon={
        loading ? (
          <CircularProgress size={14} sx={{ color: active ? '#fff !important' : '#1f5b40 !important' }} />
        ) : undefined
      }
      sx={{
        height: 24,
        fontWeight: 600,
        fontSize: '0.6875rem',
        minWidth: 85,
        ...getStatusColorSx(effectiveColor, active),
        cursor: onClick && !loading ? 'pointer' : 'default',
        ...sx
      }}
    />
  );
}

TableStatusChip.propTypes = {
  active: PropTypes.bool,
  label: PropTypes.string,
  color: PropTypes.string,
  loading: PropTypes.bool,
  loadingLabel: PropTypes.string,
  onClick: PropTypes.func,
  sx: PropTypes.object
};

